<template>
    <div>
       <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="商品名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="商品简称">
            <el-input v-model="form.shortname"></el-input>
         </el-form-item>
          <el-form-item label="商品简介">
             <el-input v-model="form.desc"></el-input>
          </el-form-item>
          <el-form-item label="商品重量">
            <el-input v-model="form.weight" placeholder="单位克（g）"></el-input>
         </el-form-item>
         <el-form-item label="商品条码">
          <el-input v-model="form.barcode"></el-input>
       </el-form-item>
          
          <el-form-item label="商品价格">
            <el-row>
              <el-col :span="8"> 
                  <el-input placeholder="请输入价格" v-model="form.price6">
                    <template slot="prepend">省级代理价</template>
                  </el-input>
              </el-col>
              <el-col :span="8"> 
                <el-input placeholder="请输入价格" v-model="form.price5">
                  <template slot="prepend">市级代理价</template>
                </el-input>
              </el-col>
              <el-col :span="8"> 
                <el-input placeholder="请输入价格" v-model="form.price4">
                  <template slot="prepend">区域代理价</template>
                </el-input>
               </el-col>
               <el-col :span="8"> 
                <el-input placeholder="请输入价格" v-model="form.price3">
                  <template slot="prepend">门店代理价</template>
                </el-input>
               </el-col>
               <el-col :span="8"> 
                <el-input placeholder="请输入价格" v-model="form.price2">
                  <template slot="prepend">VIP客户价</template>
                </el-input>
               </el-col>
               <el-col :span="8"> 
                <el-input placeholder="请输入价格" v-model="form.price1">
                  <template slot="prepend">普通会员价</template>
                </el-input>
               </el-col>
               <el-col :span="8"> 
                <el-input placeholder="请输入价格" v-model="form.price0">
                  <template slot="prepend">注册新人价</template>
                </el-input>
               </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="商品库存">
             <el-input v-model="form.stock"></el-input>
          </el-form-item>
          <el-form-item label="封面图">
              <el-upload
                :action="uploadImgUrl"
                name='image'
                :data="{extra:'headimg',type:'goods_headimg'}"
                list-type="picture-card"
                :limit='1'
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-success='handleUploadOK'
                :on-exceed='handleExceed'
                :file-list="filelist['headimg']"	
                >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
          </el-form-item>
          <el-form-item label="轮播图">
            <el-upload
              :action="uploadImgUrl"
              name='image'
              :data="{extra:'slides',type:'slides'}"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success='handleUploadOK'
              :on-exceed='handleExceed'
              :file-list="filelist['slides']"	
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </el-form-item>
          <el-form-item label="内容介绍">
            <vue-ueditor-wrap v-model="form.content" :config="uEditConfig"></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSave">立即保存</el-button>
            <el-button @click='goBack'>取消</el-button>
          </el-form-item>
        </el-form>
    </div>  
</template>

<script>
  import VueUeditorWrap from 'vue-ueditor-wrap' 
  export default {
    components: {
          VueUeditorWrap
    },
    data() {
      const uEditorUrl=process.env.VUE_APP_UEDITOR_SERVERURL+'?token='+this.$store.state.user.token
      return {
        form: {
          id:'',
          name: '',
          shortname:'',
          desc: '',
          weight:'',
          barcode:'',
          price0:'',
          price1:'',
          price2:'',
          price3:'',
          price4:'',
          price5:'',
          price6:'',
          stock:'',
          content:'',
          ishot:false,
          headimg:[],
          slides:[]
        },
        uploadImgUrl:process.env.VUE_APP_API+"/upload/uploadImg",
        dialogImageUrl: '',
        dialogVisible: false,
        processing:false,
        filelist:[],
        uEditConfig: {
                  initialFrameHeight: 240,
                  initialFrameWidth: '100%',
                  serverUrl: uEditorUrl,
                  UEDITOR_HOME_URL: './plugins/UEditor/'
        }
      }
    },
    created(){
          this.form.id=this.$route.query.goodsid==undefined?0:this.$route.query.goodsid
          if(this.form.id!=0) this.initGoodsInfo(this.form.id)
    },
    methods: {
      onSave() {
          if(this.processing){
             this.$message.error("请等待处理完成");return false
          }
          if(this.form.name==''){
            this.$message.error("商品名称不能为空");return false
          }
          if(this.form.shortname==''){
            this.$message.error("商品简称不能为空");return false
          }
          if(this.form.desc==''){
            this.$message.error("商品简介不能为空");return false
          }
          if(this.form.weight=='' || isNaN(this.form.weight) || parseInt(this.form.weight)<=0){
            this.$message.error("商品重量设置不正确");return false
          }
          if(this.form.barcode==''){
            this.$message.error("商品条码不能为空");return false
          }
          if(this.form.price0==''|| isNaN(this.form.price0) || parseInt(this.form.price0)<=0){
            this.$message.error("商品价格设置有误");return false
          }
          if(this.form.price1==''|| isNaN(this.form.price1) || parseInt(this.form.price1)<=0){
            this.$message.error("商品价格设置有误");return false
          }
          if(this.form.price2==''|| isNaN(this.form.price2) || parseInt(this.form.price2)<=0){
            this.$message.error("商品价格设置有误");return false
          }
          if(this.form.price3==''|| isNaN(this.form.price3) || parseInt(this.form.price3)<=0){
            this.$message.error("商品价格设置有误");return false
          }
          if(this.form.price4==''|| isNaN(this.form.price4) || parseInt(this.form.price4)<=0){
            this.$message.error("商品价格设置有误");return false
          }
          if(this.form.price5==''|| isNaN(this.form.price5) || parseInt(this.form.price5)<=0){
            this.$message.error("商品价格设置有误");return false
          }
          if(this.form.price6==''|| isNaN(this.form.price6) || parseInt(this.form.price6)<=0){
            this.$message.error("商品价格设置有误");return false
          }
          if(this.form.stock==''|| isNaN(this.form.stock) || parseInt(this.form.stock)<0){
            this.$message.error("商品库存设置有误");return false
          }
          if(this.form.headimg.length<1){
            this.$message.error("请上传商品缩略图片");return false
          }
          if(this.form.slides.length<1){
            this.$message.error("请上传商品轮播图");return false
          }
          if(this.form.content==''){
            this.$message.error("内容介绍不能为空");return false
          }
          this.form.headimg=this.form.headimg[0]
          this.form.ishot=0
         
          this.processing=true
          this.$post("/goods/saveGoods",{goodsinfo:this.form}).then((data)=>{
               if(data.result.success){
                   this.$message({message:data.result.info,type:'success'})
                   setTimeout(()=>{this.$router.push('/goodslist')},500)
               }else{
                   this.$message.error(data.result.info)
               }
               this.processing=false
          })
      },
      initGoodsInfo(goodsid){
          this.$post("/goods/getGoodsInfo",{goodsid:goodsid}).then((data)=>{
             if(data.result.success){
                this.form=data.result.info.goodsinfo
                this.filelist=data.result.info.filelist
             }else{
                this.$message.error(data.result.info)
             }
          })
      },
      goBack(){
          this.$go("/goodslist")
      },
      handleRemove(file, fileList) {
        let type=file.response.result.info.extra
        switch(type){
          case 'headimg':
                this.form.headimg=this.getSlides(fileList);break;
          case 'slides':
                this.form.slides=this.getSlides(fileList);break;  
          default:
                this.$message("图片类型错误");      
        }
      },
      handleUploadOK(response, file, fileList){
        let type=response.result.info.extra
        switch(type){
          case 'headimg':  
                this.form.headimg=this.getSlides(fileList);break;    
          case 'slides':
                this.form.slides=this.getSlides(fileList);break;
          default:
                this.$message("图片类型错误");      
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      getSlides(fileList){
         return fileList.map((item)=>item.response.result.info.url)
      },
      handleExceed(){
         this.$message.error("超出最大上传数量");
      }  
    }
  }
</script>

<style scoped lang="scss">

</style>
